import { render, staticRenderFns } from "./TripSettings.vue?vue&type=template&id=36dd1e2c&scoped=true"
import script from "./TripSettings.vue?vue&type=script&lang=js"
export * from "./TripSettings.vue?vue&type=script&lang=js"
import style0 from "./TripSettings.vue?vue&type=style&index=0&id=36dd1e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dd1e2c",
  null
  
)

export default component.exports